import moment from 'moment';
import 'moment/min/locales';
import sortBy from 'lodash/sortBy';


export const formatDate = (value, langCode) => {
  const dateFormatOptions = {
    month: 'short', day: 'numeric', year: 'numeric'
  }
  return new Intl.DateTimeFormat(langCode || 'en', dateFormatOptions).format(new Date(value));
}

export const formatChartDate = (date, dateFormatOptions, langCode) => new Intl.DateTimeFormat(langCode === 'en' ? 'en-GB' : langCode, dateFormatOptions).format(date)

export const getEndDate =()=>{
  const nextMonth = moment().add(1, 'months');
  const endDate= moment(nextMonth).endOf('months');
  return endDate;
}


export const getChartData = (data, numDays) => {
  const chartData = sortBy(data, (item) => item.date).slice(0, numDays);
  return chartData.map((item) => {
    const date = new Date(item.date);
    return {
      x: date,
      y: item.price.value,
      date: item.date,
      price: item.price,
    };
  });
}
